import { ResultsPanel } from "@/components/Search/SearchBar/components/ResultsPanel/resultsPanel";
import { SearchBox } from "@/components/Search/SearchBar/components/SearchBox/searchBox";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { Base } from "@/components/Search/SearchBar/searchBar.base";

export const SearchBar = Object.assign(Base, {
    useContext: useSearchBarContext,
    SearchBox: SearchBox,
    ResultsPanel: ResultsPanel
});
